import { useState } from 'react'
import { Modal } from '@pepper/ui'

import Uploader from './Uploader'
import ManualForm from './ManualForm'

import s from './ImportModal.module.css'

type Props = {
  companyId: string
  projectId: string
  open: boolean
  onClose: () => void
  setIsAddingBulkKeywords: (value: boolean) => void
}

export const ImportModal: React.FC<Props> = ({
  open,
  onClose,
  companyId,
  projectId,
  setIsAddingBulkKeywords,
}) => {
  const [viewMode, setViewMode] = useState<'INITIAL' | 'MANUAL' | 'UPLOAD'>(
    'INITIAL'
  )

  const showManualForm = ['INITIAL', 'MANUAL'].includes(viewMode)
  const showUploader = ['INITIAL', 'UPLOAD'].includes(viewMode)

  const handleClose = () => {
    setViewMode('INITIAL')
    onClose()
  }

  return (
    <Modal
      visible={open}
      title="Import Keywords"
      onCancel={handleClose}
      destroyOnClose={true}
      footer={null}
    >
      {showManualForm && (
        <ManualForm
          companyId={companyId}
          projectId={projectId}
          onClose={handleClose}
          setIsAddingBulkKeywords={setIsAddingBulkKeywords}
          showFooter={viewMode === 'MANUAL'}
          onBack={() => setViewMode('INITIAL')}
          onChange={() => setViewMode('MANUAL')}
        />
      )}
      {viewMode === 'INITIAL' && <div className={s.separator} />}
      {showUploader && (
        <Uploader
          companyId={companyId}
          projectId={projectId}
          onClose={handleClose}
          setIsAddingBulkKeywords={setIsAddingBulkKeywords}
          showFooter={viewMode === 'UPLOAD'}
          onBack={() => setViewMode('INITIAL')}
          onChange={() => setViewMode('UPLOAD')}
        />
      )}
    </Modal>
  )
}
